import Form from '../../../../display/forms/FormElements'

import api from '../../../../configs/api'

const elements =
[
    {
        type : Form.TEXTFIELD ,
        init :
        {
            id           : 'name',
            label        : 'Nom de la maladie',
            autoFocus    : true,
            fullWidth    : true,
            helperText   : 'Obligatoire',
            margin       : 'normal',
            required     : true,
            select       : false,
            autoComplete : 'off' ,
            type         : 'text',
            variant      : 'outlined'
        }
    },
    {
        type : Form.SEARCH_SELECTOR ,
        path : api.thesaurus.diseases_types ,
        init :
        {
            id         : 'additionalType',
            key        : 'additionalType',
            label      : 'Type de la maladie',
            autoFocus  : false,
            fullWidth  : true,
            margin     : 'normal',
            type       : 'search',
            variant    : 'outlined'
        },
        selector : { i18n :
        {
            empty       : 'Aucun type de maladie disponible.' ,
            title       : 'Sélectionner un type de maladie',
            description : 'Veuillez sélectionner un type de maladie ci-dessous.' ,
        }}
    },
    {
        type : Form.SEARCH_SELECTOR ,
        path : api.thesaurus.medical_levels ,
        init :
        {
            id         : 'level',
            key        : 'level',
            label      : 'Niveau de la maladie',
            autoFocus  : false,
            fullWidth  : true,
            margin     : 'normal',
            type       : 'search',
            variant    : 'outlined'
        },
        selector : { i18n :
        {
            empty       : 'Aucun niveau de maladie disponible.' ,
            title       : 'Sélectionner un niveau de maladie',
            description : 'Veuillez sélectionner un niveau de maladie ci-dessous.' ,
        }}
    }
];

export default
{
    add :
    {
        elements,
        agree       : 'Créer' ,
        disagree    : 'Annuler' ,
        title       : 'Ajouter une maladie' ,
        description : 'Veuillez remplir le formulaire ci-dessous pour créer une nouvelle fiche.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en  cours...' ,
        success     : 'Ajout du nouvel enregistrement réussi!' ,
    },
    remove :
    {
        agree        : 'Supprimer' ,
        description  : 'Souhaitez-vous supprimer la maladie suivante :' ,
        descriptionX : 'Souhaitez-vous supprimer les {0} maladies suivantes :' ,
        disagree     : 'Annuler' ,
        loading      : 'Suppression en cours...' ,
        title        : 'Supprimer cet objet ?',
        titleX       : 'Supprimer des objets ?'
    }
};
